import { render, staticRenderFns } from "./u-popover.vue?vue&type=template&id=5e192536&scoped=true&"
import script from "./u-popover.vue?vue&type=script&lang=js&"
export * from "./u-popover.vue?vue&type=script&lang=js&"
import style0 from "./u-popover.vue?vue&type=style&index=0&id=5e192536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e192536",
  null
  
)

export default component.exports